var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCartSvGs = function SvgCartSvGs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cartSVGs_svg__a",
    d: "M0 4h18l-3.033 12H3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 5A5 5 0 0 0 4 5",
    id: "cartSVGs_svg__b"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "cartSVGs_svg__c",
    x: 0,
    y: 0,
    width: 18,
    height: 12,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cartSVGs_svg__a"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "cartSVGs_svg__d",
    x: 0,
    y: 0,
    width: 10,
    height: 10,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cartSVGs_svg__b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    stroke: "#121212",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    mask: "url(#cartSVGs_svg__c)",
    xlinkHref: "#cartSVGs_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    mask: "url(#cartSVGs_svg__d)",
    xlinkHref: "#cartSVGs_svg__b"
  }))));
};
export default SvgCartSvGs;